import React from 'react'
import CouponList from '../components/coupons/CouponList'

function CouponsPage() {
  return (
    <div className='coupons-page'>
      <CouponList />
    </div>
  )
}

export default CouponsPage
